'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _HotelSearchBox = require('../containers/HotelSearchBox');

var _HotelSearchBox2 = _interopRequireDefault(_HotelSearchBox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function GlobalError(props) {
  var title = props.title,
      message = props.message,
      displaySearchForm = props.displaySearchForm;


  return _react2.default.createElement(
    'div',
    { className: 'full-width-box server-error' },
    _react2.default.createElement(
      'div',
      { className: 'fluid-error' },
      _react2.default.createElement(
        'p',
        null,
        _react2.default.createElement(
          'span',
          { className: 'error-title' },
          title
        ),
        _react2.default.createElement(
          'span',
          { className: 'error-detail' },
          message
        )
      ),
      displaySearchForm ? _react2.default.createElement(
        'div',
        { className: 'hero-search' },
        _react2.default.createElement(
          'div',
          { className: 'full-width-box hotel-list-search' },
          _react2.default.createElement(
            'div',
            { className: 'fluid-searchform' },
            _react2.default.createElement(_HotelSearchBox2.default, null)
          )
        )
      ) : null
    )
  );
}

GlobalError.propTypes = {
  title: _react.PropTypes.string.isRequired,
  message: _react.PropTypes.string,
  displaySearchForm: _react.PropTypes.bool
};

exports.default = GlobalError;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/GlobalError.js
// module id = 1205
// module chunks = 0